import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type TextSection } from '../../../types'

const emailBuilderQueue = useBuilder('emailBuilder')

const TextCommands = {
  updateBlock: emailBuilderQueue.createBlockCommand<TextSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { TextCommands }
